<template>

    <fieldset class="ecm-filters">

        <legend> {{ $t("typeFiltersLegend") }} </legend>

            <ul class="ecm-filters-list">

                <li class="ecm-form-group-cb">
                    <label for="markersCB"> {{ $t("marker") }} </label>
                    <input
                        id="markersCB"
                        type="checkbox"
                        class="ecm-checkbox"
                        @change="toggleMarkers"
                        checked />
                </li>

                <li class="ecm-form-group-cb">
                    <label for="routesCB" :class="{disabled: routesDisabled}"> {{ $t("route") }} </label>
                    <input
                        id="routesCB"
                        type="checkbox"
                        class="ecm-checkbox"
                        @change="toggleRoutes"
                        :disabled="routesDisabled"
                        checked />
                </li>

            </ul>

    </fieldset>

</template>

<script>
import {eventBus} from '../main.js';
import { store } from '../store/store';

export default {
    name: 'FiltersTypes',
    props: {

    },
    store: store,
    computed: {
        config() {
            return store.state.config;
        },
        routesDisabled() {
            return store.state.routesDisabled
        }
    },
    data() {
        return {

        }
    },
    methods: {
        toggleMarkers() {
            eventBus.$emit('toggleMarkers');
        },
        toggleRoutes() {
            eventBus.$emit('toggleRoutes');
        }
    }
}

</script>

<style scoped>

</style>
